{
  "(optional)": "(дополнительно)",
  "(required)": "(обязательно)"
}